"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M321.3 183.5l31.2 54c6.1 8.6 4 20.6-4.6 26.7l-14.6 8.8c-6.1 3.1-13.4 2.4-18.8-1.9-2.7-2-5-4.6-6.7-7.5l-31.2-54c-1.6-3-2.6-6.2-3.1-9.6-1-6.8 2.1-13.5 7.9-17.1l15-8.8c9.6-4.1 20.6.1 24.9 9.4zM263.5 216.8l4-2.3 31.2 54.1-4 2.3c-7.8 4.5-17.7 1.8-22.2-5.9l-15-26c-4.4-7.7-1.8-17.7 6-22.2zM332.1 285.4l27.1-15.6 25.1 43.5c3.4 5.9 1.4 13.4-4.5 16.8l-6 3.4c-5.8 3.3-13.2 1.4-16.5-4.4l-25.2-43.7z"
  }), (0, _core.jsx)("path", {
    d: "M395.9 104.2l62.5 108.7c-36.9-2.5-73.8 6-105.8 24.6l-31.2-54c32.1-18.5 58-46.1 74.5-79.3z"
  }), (0, _core.jsx)("circle", {
    cx: "169.2",
    cy: "169",
    r: "64.8"
  }), (0, _core.jsx)("path", {
    d: "M170.3 266.2c-64.6-.1-119.4 47.3-128.5 111.3-1.2 8.9 5.1 17 14 18.2.7.1 1.3.1 2 .1h224.8c9 0 16.2-7.3 16.2-16.3 0-.7 0-1.3-.1-2-9.3-63.8-64-111.2-128.4-111.3zM327.6 288l36.1-20.8c14.9-8.6 34.1-3.5 42.7 11.4 8.6 14.9 3.5 34.1-11.4 42.7l-36.1 20.8c-14.9 8.6-34.1 3.5-42.7-11.4-8.7-15-3.6-34.1 11.4-42.7z"
  }));
};

exports.default = _default;